// import logo from './logo.svg';
import './App.css';
import {Button, Col, Row, Container, ListGroup} from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.css';
import {ToastContainer, toast} from 'react-toastify';
import {BrowserRouter as Router, Route, Routes, Link} from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Course from './components/Course';
import AllCourse from './components/AllCourse';
import AddCourse from './components/AddCourse';
import Menu from './components/Menu';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';


function App() {

  
  return (
    <div className="App">     
      
      <Router>
        <ToastContainer />
        <Container>
          <Header/>
          <Row>

            <Col md={4} style={{textAlign:'left'}} >
              <Menu/>

            </Col>

            <Col md={8} style={{textAlign:'left'}} >
              {/* <Home/> */}
              <Routes>
                <Route path="/" Component={Home} exact />
                <Route path="/add-course" Component={AddCourse} exact/>
                <Route path="/view-courses" Component={AllCourse} exact />
                <Route path="/about-us" Component={AboutUs} exact/>
                <Route path="/contact" Component={Contact} exact/>
              
              </Routes>
             
            </Col>

          </Row>

        </Container>
      </Router>
      
    </div>
  );
}

export default App;
